// extracted by mini-css-extract-plugin
export default {"PrintOnly":"PrintHeaderFooter_PrintOnly__WopPk","Body":"PrintHeaderFooter_Body__87+os","Logo":"PrintHeaderFooter_Logo__l3cVG"};